__turbopack_context__.v({
  "confirm_email": "ConfirmEmail-module-scss-module___1zdFW__confirm_email",
  "confirm_email__options": "ConfirmEmail-module-scss-module___1zdFW__confirm_email__options",
  "user_email": "ConfirmEmail-module-scss-module___1zdFW__user_email",
});
